import { EditorState } from 'draft-js';
import { getSelectionEntity } from 'draftjs-utils';
import { StrategyLookup } from './types';

export function getContentState(editorState: EditorState) {
  if (!editorState) {
    throw new Error('getContentState called without EditorState');
  }
  return editorState.getCurrentContent();
}

export function getSelectedEntity(editorState: EditorState) {
  const entity = getSelectionEntity(editorState);
  if (!entity) {
    return null;
  }
  return getContentState(editorState).getEntity(entity);
}

export function getSelectedEntityData(editorState: EditorState) {
  const entity = getSelectedEntity(editorState);
  return entity && entity.getData();
}

export function getEntityStrategyByType(...args: StrategyLookup) {
  const [type, contentBlock, callback, contentState] = args;

  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    if (!entityKey) {
      return null;
    }
    return contentState.getEntity(entityKey).getType() === type;
  }, callback);
}

export function isCollapsed(editorState: EditorState) {
  return getSelection(editorState).isCollapsed();
}

export function getSelection(editorState: EditorState) {
  return editorState.getSelection();
}
